// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aee5b7c44e--wrapper--k65Kq","slider":"aee5b7c44e--slider--vSbSl","slider-inner":"aee5b7c44e--slider-inner--_2Xdk","thumbnails":"aee5b7c44e--thumbnails--nOXux"};